import React, { Component } from 'react';
import Particles from 'react-particles-js';

const particleStyle = {
    top: 0,
    left: 0,
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: "-10",
}

class ParticlesContainer extends Component {
    render() {
        return (
            <Particles
                style={particleStyle}
                params={{
                    "particles": {
                        "number": {
                            "value": 100,
                            "density": {
                                "enable": true,
                                "value_area": 1000
                            }
                        },
                        "size": {
                            "value": 2
                        },
                        "opacity": {
                            "value": 0.2
                        },
                        "line_linked": {
                            "opacity": 0.2
                        },
                    }
                }} />
        )
    }
}

export default ParticlesContainer;